<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>卡基础信息&nbsp;&nbsp;说明:</h5><br>
				<span>1、资料信息共用,不分归属。可以提前设置标准明细,供做相关业务单据使用时调用。</span><br>
				<span class="red">2、模式=0:不做油卡限制,但是只能对油卡合计不能细分。</span><br>
				<span class="red">3、模式=1:油卡录入要有卡号,但是不对油卡信息检查核对。合计时可以按卡号计算余额、期初、期末</span><br>
				<span class="red">4、模式=2:油卡必须事先录入到基础信息表中,并且绑定到内部车辆。录入时如果指定费用绑定单卡,可以省略卡号录入。合计时可以按卡号计算余额、期初、期末</span><br>
				<span class="red">5、模式=3:待定</span><br>
				<span>6、查询关键字:名称、编号、分类、供应商</span><br>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="edit_mode">生成费用结算</button>
			</template>
			<template slot="pre_tan_button">
				<button @click="edit_mode">生成费用结算</button>
			</template>
		</pre-base>


	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				element_loading: false,
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "cardinfo",
					"title": "卡信息",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_cw_cardinfo',
					"upd_action": 'exp15_cw_cardinfo',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [
						{
							"name": "卡号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long3"
						},
						{
							"name": "卡类型",
							"val": "",
							"key": "card_class",
							"type": "select",
							"sel_action":"_base_cardclass",
							"sel_name":"",
							"class": "long1"
						},
						{
							"name": "更新日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": ""
						}
					],
					"parm": [
						{
							"name": "卡号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "卡类型",
							"val": "",
							"key": "card_class",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_cardclass",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						
						{
							"name": "期初金额",
							"val": "",
							"key": "amount_b",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "预警金额",
							"val": "",
							"key": "amount_f",
							"type": "number",
							"class": "long1",
							"note": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "当前余额",
							"val": "",
							"key": "amount_n",
							"type": "label",
							"class": "long1",
							"note": "",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "累计充值",
							"val": "",
							"key": "amount_in",
							"type": "label",
							"class": "long1",
							"note": "",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "累计消费",
							"val": "",
							"key": "amount_out",
							"type": "label",
							"class": "long1",
							"note": "",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "卡号"
						},
						{
							"name": "卡类型"
						},
						{
							"name": "期初金额"
						},
						{
							"name": "当前余额"
						},
						{
							"name": "累计充值"
						},
						{
							"name": "累计消费"
						},
						{
							"name": "预警金额"
						},
						
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": [],

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function() {

				console.log(this.item);

				let sheet_no = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
				}

				let confirm_txt = '';
				if (sheet_no == '') {
					// confirm_txt='请确定重新结算所有卡号的相关费用!'
					confirm_txt = '请选择需要重新结算的卡号!'

					this.$message({
						type: 'info',
						message: confirm_txt
					});

					return;
				} else {
					confirm_txt = '请确定重新结算卡号:' + sheet_no + '的相关费用!'
				}

				this.$confirm(confirm_txt, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => {
					this.check_card_end(sheet_no);
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消结算'
					});
				});

			},
			check_card_end: function(ts) {
				this.element_loading = true;
				let d = [];
				d.push(ts);
				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Method_Common('_cw_check_card_end', 0, '', d, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					if (res[0][0].flag == '0') {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});
						return;
					}

					if (res[0][0].flag == '1') {
						this.list_quick = res[1];
					}

					// console.log(this.list_quick);
				});
			}




		}
	};
</script>
<style>
</style>